var map = {
	"./canva": 43,
	"./canva.svg": 43,
	"./favicon/favicon-16x16": 44,
	"./favicon/favicon-16x16.png": 44,
	"./favicon/favicon-32x32": 45,
	"./favicon/favicon-32x32.png": 45,
	"./favicon/favicon.ico": 63,
	"./logos/designify": 46,
	"./logos/designify.svg": 46,
	"./logos/kaleido-logo": 47,
	"./logos/kaleido-logo.svg": 47,
	"./logos/removebg": 48,
	"./logos/removebg.svg": 48,
	"./logos/unscreen": 49,
	"./logos/unscreen.svg": 49,
	"./not_found": 50,
	"./not_found.png": 50,
	"./play_button": 51,
	"./play_button.png": 51,
	"./sprites/circle": 52,
	"./sprites/circle.svg": 52,
	"./sprites/dot": 53,
	"./sprites/dot.svg": 53,
	"./sprites/line": 54,
	"./sprites/line.svg": 54,
	"./thanks": 55,
	"./thanks.png": 55,
	"./ukraine_dove": 56,
	"./ukraine_dove.png": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62;